<template>
  <transition v-if="found" name="fade" mode="out-in" appear>
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  data: () => ({
    found: false
  }),
  beforeMount () {
    this.beforeEnter()
  },
  methods: {
    beforeEnter () {
      let contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      let sectionData = {}
      for (let s of this.$store.getters.sectionByContent(contentData.key)) {
        if (s.url === this.$route.params.sectionUrl) sectionData = s
      }
      for (let t of this.$store.getters.taskBySection(sectionData.key)) {
        if (t.url === this.$route.params.taskUrl) {
          this.found = true
          return
        }
      }
      const appMsg = {
        type: 'error',
        msg: 'Task not found'
      }
      this.$store.dispatch('showAppMsg', appMsg)
      this.$router.push('/content/' + contentData.url + '/' + sectionData.url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/TaskWrap.vue